import React, { useEffect, useState, useRef, useContext } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import $ from 'jquery';
import { CheckSession, FormatCurrency, GetCoockie, GetShoppingCart, UpdateShoppingCart, GetSKUDetailGlb, formatDateMMDDYYYY } from "../../GlobalScript";
import { ShoppingCartContext } from '../ShoppingCartContext';
import Cookies from 'js-cookie';
import ReactPaginate from 'react-paginate';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import CloseButton from 'react-bootstrap/CloseButton';
import PulseLoader from "react-spinners/PulseLoader";
import InputGroup from 'react-bootstrap/InputGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import HistoryDetail from '../HistoryDetail';
import FooterDealer from '../../FooterDealer.js';

export default function OrderHistory() {

    const navigate = useNavigate();
    const countPerPage = 25;
    const [pageResults, setPageResults] = useState(countPerPage);
    const [tempPage, setTempPage] = useState(countPerPage);
    const [resultsLength, setResultsLength] = useState(0);
    const [orderItems, setOrderItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [keyword, setKeyword] = useState('');
    const [status, setStatus] = useState('');
    //const [dateFrom, setDateFrom] = useState('');
    //const [dateTo, setDateTo] = useState('');
    const [dateFrom, setDateFrom] = useState(formatDateMMDDYYYY(new Date(new Date().setMonth(new Date().getMonth() - 1))));
    const [dateTo, setDateTo] = useState(formatDateMMDDYYYY(new Date()));
    const [activeRow, setActiveRow] = useState(null);
    const dropdownRef = useRef(null);
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + pageResults;
    /*const currentItems = orderItems.slice(itemOffset, endOffset);*/
    const pageCount = Math.ceil(orderItems.length / pageResults);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const currentItems = orderItems.slice(itemOffset, endOffset);
    const historyType = 'order';
    const location = useLocation();
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [OrderStatusList, setOrderStatusList] = useState(false);
    const { shoppingCart, setShoppingCart, getCookie } = useContext(ShoppingCartContext);
    const [pop, setPop] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [errorModal, setErrorModal] = useState(false);
    const [userInfo, setUserInfo] = useState(null);

    useEffect(() => {
        setShoppingCart(GetShoppingCart(shoppingCart));
        if (userInfo?.loginType !== 5) {
            document.title = 'K-Dealer - Order History';
        } else {
            document.title = 'K-Countries - Order History';
        }
    }, []);

    useEffect(() => {
        if (loading) {
            try {
                const us = getCookie();
                if (!userInfo && us) {
                    setUserInfo(us);
                }
            } catch (e) {
                console.log(e);
            }
        }
    }, [loading, userInfo])

    const handleDetailsModalShow = async (order) => {
        await GetOrderDetail(order);
        setShowDetailsModal(true);
    }

    const handleDetailsModalClose = () => {
        setShowDetailsModal(false);
        setSelectedOrder(null);
        if (location.state) {
            window.history.replaceState({}, '')
        }
    }

    const handleErrorModalShow = () => {
        setErrorModal(true);
    }

    const handleErrorModalHide = () => {
        setErrorMsg('');
        setErrorModal(false);
    }

    useEffect(() => {
        if (location.state && location.state.id && location.state.id !== '') {
            setKeyword(location.state.id);
        }
    }, [location])

    useEffect(() => {
        if (location.state && location.state.id && location.state.id !== '') {
            LoadOrders('', false);
        }
    }, [keyword])

    useEffect(() => {
        if (location.state && location.state.id && location.state.id !== '' && orderItems && orderItems.length > 0) {
            handleDetailsModalShow(orderItems[0])
        }
    }, [orderItems])

    const GetOrderDetail = async (order) => {
        const response = await fetch("kdealer/GetOrderDetail/" + order.orderID + "/1");
        if (response.status !== 200) {
            return;
        }
        const items = await response.json();
        const orderToShow = {
            order: order,
            orderDetail: items
        }
        setSelectedOrder(orderToShow);
    }

    useEffect(() => {
        if (loading === true) {
            LoadOrders('', false);
            setLoading(false);
        }
    }, [loading]);

    useEffect(() => {
        if (!OrderStatusList) {
            LoadOrderStatusList();
        }
    }, [OrderStatusList]);

    const ResetSearch = async () => {
        setKeyword('');
        setStatus('');
        setDateFrom('');
        setDateTo('');
        setLoading(true);
    }

    const LoadOrderStatusList = async () => {
        try {
            CheckSession();
            const response = await fetch("kdealer/GetOrderStatusList");
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setOrderStatusList(lst);
            console.log(lst)
        }
        catch (e) {
            console.log(e);
            return;
        }
    }

    const LoadOrders = async (orderby, inc) => {
        try {
            handlePop();
            CheckSession();
            const user = GetCoockie();
            const data = {
                keyword: keyword,
                status: status,
                dateFrom: dateFrom,
                dateTo: dateTo,
                orderBy: orderby,
                inc: inc,
                dealerId: user.dealerID
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch("kdealer/GetOrders", requestOptions);
            if (response.status !== 200) {
                handleClosePop();
                return;
            }
            const orders = await response.json();
            setOrderItems(orders);
            setResultsLength(orders.length);
            handleClosePop();
        } catch (e) {
            handleClosePop();
            console.log(e);
            return;
        }
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'keyword') {
            setKeyword(value);
        } else if (name === 'status') {
            setStatus(value);
        } else if (name === 'dateFrom') {
            setDateFrom(value);
        } else if (name === 'dateTo') {
            setDateTo(value);
        } else if (name === 'tempPage') {
            setTempPage(value);
        }
    }

    const handleSearchClick = async () => {
        try {
            LoadOrders('', false);
        } catch (e) {
            console.log(e);
        }
    };

    const handleReturnClick = (e, orderID, exchange) => {
        try {
            if (exchange) {
                navigate('/creditrequest', { state: { id: orderID, exchange: true } });
            } else {
                navigate('/creditrequest', { state: { id: orderID } });
            }
        } catch (e) {
            console.log(e);
        }
    };

    const handleDuplicateClick = async (e, orderID) => {
        try {
            CheckSession();
            handlePop();
            const response = await fetch("kdealer/GetOrderDetail/" + orderID + "/2");
            if (response.status !== 200) {
                setErrorMsg('There was an error while attempting to duplicate your order. Please try again later.')
                handleErrorModalShow();
                return;
            }
            const items = await response.json();
            const skuqty = [];
            items.items.forEach(element => {
                skuqty.push({
                    sku: element.sku,
                    qty: element.qty + element.boQty
                });
            });
            let orderType = "1";
            if (items.orderType === "Emergency Order") {
                orderType = "2"
            } else if (items.orderType === "Stocking Order") {
                orderType = "3"
            }
            const res = await GetSKUDetailGlb(skuqty, orderType, items.orderName, items.shipTo.dealerID);
            if (res && res.cart) {
                UpdateShoppingCart(res.cart, setShoppingCart);
                navigate('/neworder');
            }
            else if (res && res.error) {
                //error message
            }

        } catch (e) {
            console.log(e);
        } finally {
            handleClosePop();
        }
    };

    const handleCancelClick = async (e, refID) => {
        try {
            CheckSession();
            handlePop();
            const user = GetCoockie();
            const data = {
                label: user.dealerID,
                value: refID
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch("kdealer/CancelOrder", requestOptions);
            if (response.status !== 200) {
                setErrorMsg('There was an error while attempting to cancel your order. Please try again later.')
                handleErrorModalShow();
                return;
            }
            window.location.reload(false);
        } catch (e) {
            console.log(e);
        } finally {
            handleClosePop();
        }
    };

    const handlePageClick = (event) => {
        const newOffset = (event.selected * pageResults) % orderItems.length;
        console.log(
            `User requested page number ${event.selected}, which is offset ${newOffset}`
        );
        setItemOffset(newOffset);
    };

    const changePageResults = () => {
        if (tempPage && tempPage > 0 && tempPage < 1000) {
            setPageResults(tempPage);
        }
    }

    const handlePop = () => setPop(true);
    const handleClosePop = () => setPop(false);

    return (
        <>
            <Container className="checkout-container main-container dealer-section">

                <Row className="help-title-row checkout-title-row">
                    <Col className="help-center-title checkout-title">
                        <h1 className="heading help-heading">ORDER HISTORY</h1>
                    </Col>
                    <Col className="checkout-title-under">
                        {/*<Row className="excel-row">*/}
                        {/*    <Col>*/}
                        {/*        <div className="icons-row clickable">*/}
                        {/*            <img src="../../../Images/icon_excel.png" alt="Excel" className="excel-icon" />*/}
                        {/*            <p className="mb-0 underline">Excel Orders</p>*/}
                        {/*        </div>*/}
                        {/*    </Col>*/}
                        {/*    <Col>*/}
                        {/*        <div className="icons-row clickable">*/}
                        {/*            <img src="../../../Images/icon_excel.png" alt="Excel" className="excel-icon" />*/}
                        {/*            <p className="mb-0 underline">Excel Order Items</p>*/}
                        {/*        </div>*/}
                        {/*    </Col>*/}
                        {/*</Row>*/}
                    </Col>
                </Row>

                <Row>
                    <Col sm={12}>
                        <Card>
                            <Card.Body>
                                <Row>
                                    <Col sm={3}>
                                        <FloatingLabel label="Keyword" className="mb-4">
                                            <Form.Control id="keyword" type="text" placeholder="Keyword" value={keyword} className={'form-control'} onChange={handleChange} name="keyword" />
                                        </FloatingLabel>
                                    </Col>
                                    <Col sm={3}>
                                        <FloatingLabel label="Order Type" className="mb-4">
                                            <Form.Select aria-label="Status" onChange={handleChange} value={status} name="status" className="tall-select">
                                                <option value={''}>All</option>
                                                {
                                                    OrderStatusList && OrderStatusList.map((item, index) => (
                                                        <option key={item.value} value={item.value}>{item.label}</option>
                                                    ))
                                                }
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Col>
                                    <Col sm={3}>
                                        <FloatingLabel label="Date From" className="mb-4">
                                            <Form.Control id="dateFrom" type="text" placeholder="Date From" value={dateFrom} className={'form-control'} onChange={handleChange} name="dateFrom" />
                                        </FloatingLabel>
                                    </Col>
                                    <Col sm={3}>
                                        <FloatingLabel label="Date To" className="mb-4">
                                            <Form.Control id="dateTo" type="text" placeholder="Date To" value={dateTo} className={'form-control'} onChange={handleChange} name="dateTo" />
                                        </FloatingLabel>
                                    </Col>

                                    <Col sm={{ offset: 8 }} className="text-right" style={{ alignSelf: 'center' }}>
                                        <p className="clickable underline green-text" onClick={ResetSearch}>Reset Search</p>
                                    </Col>

                                    <Col className="text-center mb-3">
                                        <Button variant="secondary" onClick={handleSearchClick}>
                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                            </svg>
                                            SEARCH
                                        </Button>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mt-5 mb-4">
                    <Col sm={12}>
                        <Card className="">
                            <Card.Body>
                                <Row className="table-legend text-center">
                                    <Col sm={12}>
                                        {/*<div className="table-legend-section">*/}
                                        {/*    <span className="svg-holder"><img src="../../../Images/parts.svg" alt="" className="" /> Parts</span>*/}
                                        {/*    <span className="svg-holder"><img src="../../../Images/accessories.svg" alt="" className="" /> Accessories</span>*/}
                                        {/*    <span className="svg-holder"><img src="../../../Images/other.svg" alt="" className="" /> Other</span>*/}
                                        {/*</div>*/}
                                        <div className="table-legend-section">
                                            {userInfo?.loginType === 5 &&
                                                <>
                                                    <span className="svg-holder"><img src="../../../Images/Allocated.svg" alt="" className="" /> Allocated</span>
                                                    <span className="svg-holder"><img src="../../../Images/AllocationProcessing.svg" alt="" className="" /> Allocation Processing</span>
                                                </>
                                            }
                                            <span className="svg-holder"><img src="../../../Images/partially-shipped.svg" alt="" className="" /> Partially Shipped</span>
                                            <span className="svg-holder"><img src="../../../Images/shipped-active.svg" alt="" className="" /> Shipped</span>
                                            {userInfo?.loginType !== 5 &&
                                                <span className="svg-holder"><img src="../../../Images/returned.svg" alt="" className="" /> Returned</span>
                                            }
                                            <span className="svg-holder"><img src="../../../Images/queued.svg" alt="" className="" /> Queued</span>
                                            <span className="svg-holder"><img src="../../../Images/processing.svg" alt="" className="" /> Processing</span>
                                            <span className="svg-holder"><img src="../../../Images/cancelled-inactive.svg" alt="" className="" /> Cancelled</span>
                                        </div>
                                        <div className="table-legend-section">
                                            <span className="svg-holder"><img src="../../../Images/backorder.svg" alt="" className="" /> Backorder</span>
                                        </div>
                                    </Col>
                                </Row>

                                <Row className="pagination-row">
                                    <Col sm={12}>
                                        <p>
                                            <span className="bold">{resultsLength > 0 && resultsLength}</span> results | View
                                            <div className="paginate-results">
                                                <input name="tempPage" type="text" value={tempPage} onChange={handleChange} className="form-control" />
                                                <button className="btn btn-black btn-pagenav" onClick={changePageResults}>Go</button>
                                            </div>
                                        </p>

                                        <ReactPaginate
                                            breakLabel="..."
                                            nextLabel="next >"
                                            onPageChange={handlePageClick}
                                            pageRangeDisplayed={5}
                                            pageCount={pageCount}
                                            previousLabel="< previous"
                                            renderOnZeroPageCount={null}
                                            containerClassName="table-navigation"
                                            previousLinkClassName="table-nav-link"
                                            nextLinkClassName="table-nav-link"
                                        />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col sm={12} className={currentItems.length > 2 ? "order-table" : "order-table no-scroll-lg"}>
                                        <Table hover responsive>
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>ORDER #</th>
                                                    <th>ORDER <br /> DATE</th>
                                                    <th>ORDER <br /> TYPE</th>
                                                    <th>ORDERED BY</th>
                                                    <th>SHIP <br /> METHOD</th>
                                                    <th>STATUS</th>
                                                    <th>TOTAL <br /> ITEMS</th>
                                                    <th>TOTAL</th>
                                                    <th width="9%"></th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentItems && currentItems.map((item, index) => (
                                                    <tr className="" key={item.refID}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            <table className="inner-table">
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="bold">Ord #</td>
                                                                        <td className="bold">{item.orderID}</td>
                                                                    </tr>
                                                                    {/*<tr>*/}
                                                                    {/*    <td>Ref #</td>*/}
                                                                    {/*    <td>{item.refID}</td>*/}
                                                                    {/*</tr>*/}
                                                                    <tr>
                                                                        <td>Name</td>
                                                                        <td>{item.orderName}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                        <td>{item.orderDate}</td>
                                                        <td>{item.orderType}</td>
                                                        <td>{item.orderById} <br /> {item.orderByName}</td>
                                                        <td>{item.shipMethod}</td>
                                                        <td className="table-img"> <span className="svg-holder"><img src={"../../../Images/" + item.statusImg} alt="" className="item-type-image" /></span></td>
                                                        <td>{item.totalItems}</td>
                                                        <td>{FormatCurrency(item.total)}</td>
                                                        <td>
                                                            <Button variant="primary" onClick={() => handleDetailsModalShow(item)}>
                                                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                                </svg>
                                                                VIEW
                                                            </Button>
                                                        </td>
                                                        <td ref={dropdownRef} style={{ position: activeRow === item.refID ? 'absolute' : 'static' }}>
                                                            <DropdownButton
                                                                variant="outline-dark"
                                                                title="Actions"
                                                                id="input-group-dropdown-1"
                                                            >
                                                                <Dropdown.Item onClick={(e) => handleDuplicateClick(e, item.orderID)} ><span className="bold">Duplicate Order</span></Dropdown.Item>
                                                                {item.exchangable && <Dropdown.Item onClick={(e) => handleReturnClick(e, item.orderID, true)}><span className="bold">Exchange</span></Dropdown.Item>}
                                                                {item.returnable && <Dropdown.Item onClick={(e) => handleReturnClick(e, item.orderID, false)}><span className="bold">Return</span></Dropdown.Item>}
                                                                {item.status === 'Queued' && <Dropdown.Item onClick={(e) => handleCancelClick(e, item.refID)}><span className="bold">Cancel Order</span></Dropdown.Item>}

                                                            </DropdownButton>
                                                        </td>
                                                    </tr>
                                                ))}

                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

            </Container>

            <FooterDealer />

            <Modal show={errorModal} onHide={handleErrorModalHide} dialogClassName="dealer-section" centered>
                <Modal.Header closeButton>
                    <Modal.Title>ERROR</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" />
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                            <p>{errorMsg}</p>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                        <Col sm={12} className="text-right">
                            <Button variant="secondary" onClick={handleErrorModalHide}>
                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                </svg>
                                CLOSE
                            </Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>

            <Modal className="loader-div" id="loader" show={pop} onHide={handleClosePop} size="lg" centered backdrop="static" keyboard={false}>
                <PulseLoader color="#66cc33" size="20px" margin="12px" />
            </Modal>

            <HistoryDetail show={showDetailsModal} handleClose={handleDetailsModalClose} order={selectedOrder} userInfo={userInfo} historyType={historyType} />
        </>
    );
}